import { flatMap, map, pick } from 'lodash-es';

const CART_ITEM_FIELDS = [
  'id',
  'quantity',
  'variation_id',
  'product_id',
  'type',
];

export const transformCartEventData = (data) => ({
  id: data?.id,
  items: flatMap(data?.items, (item) => [
    pick(item, CART_ITEM_FIELDS),
    ...map(item?.addon_items, (addonItem) => pick(addonItem, CART_ITEM_FIELDS)),
  ]),
});
